// extracted by mini-css-extract-plugin
export default {"header":"header_header__ifNzM","title":"header_title__ZJYIi","defaultButton":"header_defaultButton__ZLBU9","fadeOut":"header_fadeOut__X0u7w","fadeIn":"header_fadeIn__kKU2Z"};